<template lang="html">
    <div class="page-container">
        <div class="page-container__header">
            <h1 class="header-1 page-container__title">Toate Notificarile</h1>
        </div>
        
        <div class="page-container__body" v-if="allNotifications.length > 0">
            <template v-for="(notification, index) in notificationsDisplay">
                <div class="notifications-page__day" v-if="notification.time !== undefined" :key="'pg-' + index">
                    {{calendar(notification.time)}}
                </div>
                <NotificationItem
                    v-else
                    :key="'notification' + index"
                    :type="notification.type"
                    :title="notification.title"
                    :text="notification.message"
                    :date="notification.created_at"
                    :imageUrl="notification.image_url"
                    :link="notification.link"
                    :initiator="notification.initiator"
                    :user="user"
                />
            </template>
            <div class="notifications-page__trigger"></div>
            
            <div v-if="lastNotificationsPageIndex == currentIndex-1" 
                class="notifications-page__info">
                Nu mai există notificari de încărcat
            </div>
        </div>
        
        <div v-if="isLoading == true" class="notifications-page__loading">
            <i class="fas fa-spinner fa-spin fa-2x"></i>
        </div>
        
        <div class="page-container__body" v-else-if="allNotifications.length == 0 && isLoading == false">
            <div class="notifications-page__empty-text">
                Nu există notificari noi
            </div>
            <div class="notifications-page__image">
                <img src="@/assets/images/no-new-notifications-image.svg" alt="No new notifications">
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import NotificationItem from './components/NotificationItem';

export default {
    components: {
        NotificationItem
    },
    created () {
        window.addEventListener('scroll', this.onScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.onScroll);
    },
    data() {
        return {
            offsetTop: 0,
            currentIndex: 1,
            canRequest: true
        }
    },
    computed: {
        ...mapGetters({
            allNotifications: "notification/allNotifications",
            lastNotificationsPageIndex: "notification/lastNotificationsPageIndex",
            user: "user/user",
            isLoading: "notification/isLoading"
        }),
        notificationsDisplay() {
            const object = {};
            for (const notification of this.allNotifications) {
                const timeStampStart = this.$moment(notification.created_at);
                const daytime = timeStampStart.format('YYYY-MM-DD');
                object[daytime] ??= [];
                object[daytime].push(notification);
            }
            let feed = [];
            for (const daytime in object) {
                feed.push({ time: daytime });
                feed = feed.concat(object[daytime]);
            }

            var notificationsIds = [];
            feed.forEach((notification, index) => {
                if(notification.id && notification.status == 'sent')
                    notificationsIds.push(notification.id);
            });
            
            if(notificationsIds.length)
                this.readNotifications({
                    ids: notificationsIds,
                    next: false
                });
            return feed;
        }
    },
    methods: {
        ...mapActions({
            fetchNotifications: "notification/fetchNotifications",
            readNotifications: 'layout/readNotifications',
        }),
        calendar(timestamp) {
            let timestampString = this.$moment(timestamp, "YYYY-MM-DD").calendar().split(' la', 2)[0];
            if(timestampString.charAt(0).toUpperCase() != timestampString.charAt(0).toLowerCase() && timestampString.includes(","))
            {
                timestampString = timestampString.substr(0, timestampString.indexOf(','));
            }
            return timestampString.charAt(0).toUpperCase()+timestampString.slice(1);
        },
        onScroll() {
            this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
        },
        isElementInViewport(el) {
            var rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
    },
    watch: {
        offsetTop() {
            let trigger = document.querySelector(".notifications-page__trigger");
            if(this.isElementInViewport(trigger) && this.currentIndex <= this.lastNotificationsPageIndex && this.canRequest)
            {
                this.fetchNotifications(this.currentIndex++);
                this.canRequest = false;
            }
        },
        allNotifications() {
            setTimeout(() => {
                this.canRequest = true;
            }, 500)
        }
    },
    mounted() {
        this.fetchNotifications(1);
        this.currentIndex++;
    }
}
</script>

<style lang="scss" scoped>
    @import "@/scss/pages/notifications";
</style>


